import DashbordSidebar from 'organization/theme/Sidebar'
import React from 'react'

export default function DashboardPage(props: {
  children: React.ReactElement
  sidebar?: React.JSX.Element
  disableModals?: boolean
  modals?: React.ReactElement
  header?: React.ReactElement
}) {
  return (
    <main className={`body-area bd-theme-light`}>
      {props.disableModals ?? props.modals}
      <div className="page__full-wrapper">
        {props.sidebar ?? <DashbordSidebar />}
        <div className="page__body-wrapper">
          {props.header}
          <div className="app__slide-wrapper">{props.children}</div>
        </div>
      </div>
    </main>
  )
}
